<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('job_search')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3">
          <el-tooltip
            placement="top"
            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
              <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>
          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_job_search") }}</h5>
          <p class="mb-0">{{ $t("introduction_job_search") }}</p>
          <!-- <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("view") }} :</strong> {{ $t("view_my_site_detail") }}</li>
          </ul> -->
        </div>
      </div>
    </div>

    <app-table
      :id="tableId"
      :options="options"
      :card-view="true"
      @action="getListAction"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
    
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../../core/helpers/app/AppFunction";

export default {
  extends: CoreLibrary,
  name: "GridView",
  mixins: [TableHelpers],
  data() {
    return {
      instructionShow: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "grid-view-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.JOB_SEARCH,
        cardViewComponent: "job-grid",
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("user"),
            type: "media-object",
            key: "media-object",
            mediaTitleKey: "title",
            mediaSubtitleKey: "email",
            default: AppFunction.getAppUrl("images/avatar-demo.jpg"),
            modifier: (value, row) => {
              return value; // imag url
            },
            isVisible: true,
          },
          {
            title: this.$t("description"),
            type: "text",
            key: "description",
          },
          {
            title: this.$t("start_date"),
            type: "text",
            key: "start_date",
          },
          {
            title: this.$t("end_date"),
            type: "text",
            key: "end_date",
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "active") ClassName = `success`;
              else if (value === "invited") ClassName = `warning`;

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          {
            title: this.$t("start_date"),
            type: "text",
            key: "start_date",
          },
          {
            title: this.$t("gender"),
            type: "custom-html",
            key: "gender",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view_job"),
            // icon: "eye",
            type: "none",
            // component: 'app-add-modal',
            // modalId: 'demo-add-edit-Modal',
          },
          {
            title: this.$t("add_to_favorite"),
            type: "none",
          },
        ],
        filters: [
          //   {
          //     title: this.$t("date"),
          //     type: "range-picker",
          //     key: "date",
          //     option: ["today", "thisMonth", "last7Days", "nextYear"],
          //   },
          {
            title: this.$t("is_private"),
            type: "checkbox",
            key: "is_private",
            option: [
              { id: "0", value: "Public" },
              { id: "1", value: "Private" },
            ],
          },
          // {
          //   title: this.$t("location"),
          //   type: "drop-down-filter",
          //   key: "search select",
          //   option: [
          //     { id: "0", value: "UK" },
          //     { id: "1", value: "USA" },
          //   ],
          // },
          {
            title: this.$t("region"),
            type: "drop-down-filter",
            key: "select_region",
            option: [
              // { id: "0", value: "Public" },
              // { id: "1", value: "Private" },
            ],
          },
          {
            title: this.$t("threshold"),
            type: "drop-down-filter",
            key: "select_threshold",
            option: [
              // { id: "0", value: "Threshold 1" },
              // { id: "1", value: "Threshold 1" },
            ],
          },
          {
            title: this.$t("favorite"),
            type: "drop-down-filter",
            key: "select_favorite_job",
            option: [
              { id: "favorite", value: "Favorite" },
            ],
          },
          //   {
          //     title: this.$t("status"),
          //     type: "checkbox",
          //     key: "status",
          //     option: [
          //       { id: "completed", value: "Completed" },
          //       { id: "incomplete", value: "Incomplete" },
          //       // {id: 'invited', value: 'Invited'},
          //     ],
          //   },
          {
            title: this.$t("search_and_select_category"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
    this.getDropdown();
  },
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("mark_as_interested")) {
          this.jobMarked(rowData.id);
      } else if (actionObj.title == this.$t("view_job")) {
        window.location = "management/" + rowData.id;
      }
    },
    jobMarked(id) {

      // alert(id);
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.CATEGORIES).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select_category")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
    getDropdown() {
      this.axiosGet(actions.DROPDOWN)
        .then((response) => {
          // this.threshold = response.data.region;
          // console.log('threshold.option',this.threshold);

          let threshold = this.options.filters.find(
            (element) => element.title === this.$t("threshold")
          );
          let region = this.options.filters.find(
            (element) => element.title === this.$t("region")
          );

          threshold.option = response.data.threshold;
          region.option = response.data.region;
        })
        .catch((error) => {
          
        });
    },
  },
  computed: {
    theemMode() {
      return this.$store.state.theme;
    },
   },
};
</script>
